import React from "react";
import { withStyles } from "@material-ui/styles";
import update from "immutability-helper";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { forEach, get, map, filter, size, isEmpty, sortBy } from "lodash";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";

import { isUnknownProfile } from "../../utils/profile";
import {
  getContextPhotosWithRoi,
  getOcrLprFromPhotos,
} from "../../utils/detectionDetails";
import { getOcrLprConfirmationCorrection } from "../../utils/event";

import CloseIcon from "../Common/CloseIcon";
import CustomInput from "../Common/CustomInput";
import CustomButton from "../Common/CustomButton";
import Loader from "../Common/Loader";
import ProfileForm from "../Profiles/ProfileForm/ProfileForm";
import ProfileMatch from "./CorrectConfirmValue/ProfileMatch";
import CapturedPhoto from "../SiteEntranceExit/CapturedPhoto";
import OverrideProfileSearch from "./OverrideProfileSearch";

//import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

import { fetchPost, fetchGet, fetchPut } from "../../api/fetch";
import { getOcrLprLatestValue } from "../../utils/detectionDetails";
import {
  CONTEXT,
  CONTEXT_LPR,
  CONTEXT_OCR,
  OCR,
  LPR,
  driver,
  truck,
  trailer,
  //container,
  human,
} from "../../constants/common";

const styles = {
  dialog: {
    minWidth: "400px",
    minHeight: "450px",
  },
  dialogCreate: {
    width: "calc(100vw - 100px)",
    maxWidth: "1382px",
    height: "calc(100vh - 200px)",
    maxHeight: "1000px",
    borderRadius: "2px",
  },
  closeBtn: {
    display: "flex",
    justifyContent: "flex-end",
  },
  options: {
    marginTop: "15px",
    marginBottom: "15px",
    color: colors.black54,
  },
  pictureContainer: {
    border: "1px solid " + colors.veryLighPink,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "80px",
    height: "80px",
  },
  formControlLabel: {
    fontSize: "1em",
  },
  profileBox: {
    width: "368px",
    maxHeight: "120px",
    overflow: "auto",
  },
  photoContainer: {
    width: "72px",
    height: "72px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "5px",
    marginTop: "10px",
    border: `1px solid ${colors.veryLighPink}`,
  },
  checkboxRoot: {
    padding: "3px",
  },
};

const OverrideDialogForm = (props) => {
  const { classes, open, closeDialog, lov } = props;
  const [selectedProfile, setSelectedProfile] = React.useState();
  const [renderCreateProfile, setRenderCreateProfile] = React.useState(false);
  const [photoSelectionStep, setPhotoSelectionStep] = React.useState(false);
  const [overrideReason, setOverrideReason] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [potentialMatches, setPotentialMatches] = React.useState([]);
  const [selectedPhotos, setSelectedPhotos] = React.useState([]);

  const { dacId, detectionId, handleProfileOverride, fr } = props.details;

  const profileType = !isNaN(parseInt(props.profileType))
    ? props.profileType
    : props.profileType === driver
    ? 1
    : props.profileType === human
    ? 1
    : props.profileType === truck
    ? 2
    : props.profileType === trailer
    ? 3
    : 4;

  const handleSubmit = async () => {
    if (
      profileType === 3 &&
      !isEmpty(get(props, ["details", "truckImages"])) &&
      !photoSelectionStep
    ) {
      setPhotoSelectionStep(true);
    } else {
      if (selectedProfile === "create") {
        setRenderCreateProfile(true);
      } else {
        if (selectedProfile) {
          try {
            setPhotoSelectionStep(false);
            setLoading(true);
            let overrideProfile = await fetchGet(`profiles/${selectedProfile}`);
            let body = {
              event_group: {
                id: detectionId || null,
                site_id: get(props, ["siteId"]),
                zone_id: get(props, ["zoneId"]),
                update_location: true,
                event: {
                  profile: {
                    id: overrideProfile.id,
                    data: overrideProfile,
                  },
                },
              },
            };
            if (!isEmpty(props.overrideAttributes)) {
              body.event_group.event.attributes = props.overrideAttributes;
            }
            if (!detectionId && overrideReason) {
              body.event_group.note = {
                description: overrideReason,
                profile_id: !isUnknownProfile(selectedProfile)
                  ? selectedProfile
                  : null,
              };
            }

            await fetchPut(`override/event_groups/${dacId}`, body);

            await transferPhotosFromTruck();

            let note;
            if (overrideReason && detectionId) {
              note = await fetchPost(`event_groups/${detectionId}/notes`, {
                description: overrideReason,
                profile_id: !isUnknownProfile(selectedProfile)
                  ? selectedProfile
                  : null,
              });
              note.related = props.profileType;
              note.author = props.user.firstName + " " + props.user.lastName;
              setOverrideReason("");
              console.log("note added for override reason");
            }
            setLoading(false);
            //dispatch(updateOneLog(tabs.tabIndex, tabs.openFrom, dacId));
            if (props.addNote) {
              props.addNote(note);
            }
            handleProfileOverride(props.profileType, overrideProfile, note);
            closeDialog();
            setPotentialMatches([]);
            setOverrideReason();
          } catch (e) {
            console.log(e);
          }
        }
      }
    }
  };

  const transferPhotosFromTruck = async () => {
    if (size(selectedPhotos) > 0) {
      let trailerIdentification = await fetchPost("new/event_groups", {
        filter: {
          parent_ids: [dacId],
          types: [11],
        },
        data: [
          "id",
          "active",
          "created_on",
          "created_by",
          "type",
          "profile",
          "event_count",
          "parent",
          {
            name: "events",
            data: ["id", "active", "created_on", "type"],
          },
        ],
      });

      trailerIdentification = get(trailerIdentification, ["items", 0]);
      let profileOverrideEvent = get(
        sortBy(
          filter(
            get(trailerIdentification, ["events"]),
            (e) => get(e, ["type", "id"]) === 64
          ),
          (e) => -e.created_on
        ),
        [0]
      );

      // Add selected photos to the event
      for (let i = 0; i < size(selectedPhotos); i++) {
        let imgName = get(selectedPhotos, [i, "url"]);
        if (imgName && imgName.includes("/api/images/")) {
          let index = imgName.indexOf("/api/images/");
          imgName = imgName.substring(index + 12);
        }
        let img = await fetchGet(`images/${imgName}`);
        let body = {
          name: imgName,
          enrollment_status: false,
          enrollment_error: false,
          main_display: false,
          "image-base64": img,
        };
        await fetchPost(
          `events/${get(profileOverrideEvent, ["id"])}/images`,
          body
        );
        console.log("image added to event");
      }

      // Remove image from truck detection event group
      await inactiveTruckEvents();
    }
  };

  const inactiveTruckEvents = async () => {
    let eventsToInactive = [];
    forEach(selectedPhotos, (p) => {
      forEach(
        get(props, ["details", "truckDetectionEventGroup", "events"]),
        (e) => {
          // Attributes
          forEach(get(e, ["attributes"]), (attr) => {
            if (attr.value === p.url) {
              eventsToInactive.push(e);
            }
          });
          // Images
          forEach(get(e, ["images"]), (img) => {
            if (img.url === p.url) {
              eventsToInactive.push(e);
            }
          });
          // Sub events
          forEach(get(e, ["events"]), (se) => {
            forEach(get(se, ["attributes"]), (attr) => {
              if (attr.value === p.url) {
                eventsToInactive.push(se);
              }
            });
          });
        }
      );
    });
    console.log("inactive events");
    for (let i = 0; i < size(eventsToInactive); i++) {
      let event = eventsToInactive[i];
      try {
        await fetchPut(
          `event_groups/${get(event, ["group", "id"])}/events/${get(event, [
            "id",
          ])}`,
          { active: false }
        );
      } catch (e) {
        console.log(e);
      }
    }
  };

  const handleCreateProfile = async (type, profileId, deviceId = null) => {
    try {
      setRenderCreateProfile(false);
      setLoading(true);
      let overrideProfile = await fetchGet("profiles/" + profileId);
      let body = {
        event_group: {
          id: detectionId || null,
          site_id: get(props, ["siteId"]),
          zone_id: get(props, ["zoneId"]),
          event: {
            device: {
              id: deviceId,
            },
            profile: {
              id: overrideProfile.id,
              data: overrideProfile,
            },
          },
        },
      };
      let override = await fetchPut("override/event_groups/" + dacId, body);
      console.log("profile overriden", override);
      let note;
      if (overrideReason) {
        note = await fetchPost("event_groups/" + detectionId + "/notes", {
          description: overrideReason,
          profile_id: profileId,
        });
        note.author = props.user.firstName + " " + props.user.lastName;
        note.related = type;
        console.log("note added for override reason");
      }
      await props.addNote(note);
      // Remove image from truck detection event group
      await transferPhotosFromTruck();
      handleProfileOverride(type, overrideProfile, note);
      setRenderCreateProfile(false);
      closeDialog();
    } catch (e) {
      console.log(e);
    }
  };

  const getFrPhotos = () => {
    if (fr) {
      return fr
        .filter((item) => item.img !== undefined && item.img !== "")
        .map((item) => item.img);
    }
    return [];
  };

  const isSelected = (img) => {
    return size(filter(selectedPhotos, (p) => p.url === img.url)) > 0;
  };

  const selectImg = (img) => {
    if (isSelected(img)) {
      let index;
      forEach(selectedPhotos, (p, i) => {
        if (p.url === img.url) {
          index = i;
        }
      });
      setSelectedPhotos(
        update(selectedPhotos, {
          $splice: [[index, 1]],
        })
      );
    } else {
      setSelectedPhotos(
        update(selectedPhotos, {
          $push: [img],
        })
      );
    }
  };

  const getTruckImages = (contextPhotos, ocr, lpr) => {
    let photos = [];
    let photosNameSet = new Set();

    // Context photos
    forEach(contextPhotos, (img) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: img.url,
          type: CONTEXT,
          values: [],
          matched: false,
        },
        get(props, ["details", "truckDetectionEventGroup"])
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // Context photos from LPR cropped photos
    forEach(getContextPhotosWithRoi([lpr]), (img) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: img.contextImage,
          type: CONTEXT_LPR,
          values: [],
          matched: false,
          roiOverlay: img.roiOverlay,
        },
        get(props, ["details", "truckDetectionEventGroup"])
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // Context photos from OCR cropped photos
    forEach(getContextPhotosWithRoi([ocr]), (img) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: img.contextImage,
          type: CONTEXT_OCR,
          values: [],
          matched: false,
          roiOverlay: img.roiOverlay,
        },
        get(props, ["details", "truckDetectionEventGroup"])
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // LPR cropped photos
    forEach(lpr, (rec) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: rec.croppedImage,
          type: LPR,
          values: [rec.text],
        },
        get(props, ["details", "truckDetectionEventGroup"])
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // OCR cropped photos
    forEach(ocr, (rec) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: rec.croppedImage,
          type: OCR,
          values: rec.values,
        },
        get(props, ["details", "truckDetectionEventGroup"])
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });
    return photos;
  };

  if (renderCreateProfile) {
    let attributes = getOcrLprLatestValue(props.photos).filter(
      (v) => v.value !== ""
    );
    const lprAttr = attributes.filter((v) => v.id === 44);
    const ocrAttr = attributes.filter((v) => v.id === 50);
    attributes = [...ocrAttr];
    if (lprAttr && lprAttr.length > 0) {
      attributes.push(lprAttr[0]);
    }

    if (!isEmpty(get(props, ["details", "truckImages"]))) {
      const truckImages = getTruckImages(
        get(props, ["details", "truckImages", "contextPhotos"]),
        get(props, ["details", "truckImages", "ocr"]),
        get(props, ["details", "truckImages", "lpr"])
      );
      const lprs = map(
        filter(
          truckImages,
          (img) => img.type === LPR && size(get(img, ["values"])) > 0
        ),
        (img) => get(img, ["values", 0])
      );
      const ocrs = map(
        filter(
          truckImages,
          (img) => img.type === OCR && size(get(img, ["values"])) > 0
        ),
        (img) => get(img, ["values", 0])
      );
      attributes.push(...map(lprs, (v) => ({ id: 44, value: v })));
      attributes.push(...map(ocrs, (v) => ({ id: 50, value: v })));
    }

    return (
      <Dialog
        open={renderCreateProfile}
        fullWidth
        classes={{ root: classes.root, paperScrollPaper: classes.dialogCreate }}
      >
        <ProfileForm
          profileType={
            props.profileType === driver
              ? 1
              : props.profileType === truck
              ? 2
              : props.profileType === trailer
              ? 3
              : 4

          }
          profile={{
            profile_type_id:
              props.profileType === driver
                ? 1
                : props.profileType === truck
                ? 2
                : props.profileType === trailer
                ? 3
                : 4,
            attributes,
          }}
          setCreatedProfile={(p) =>
            handleCreateProfile(props.profileType, p.id)
          }
          close={() => setRenderCreateProfile(false)}
          photos={
            props.profileType === driver
              ? getFrPhotos()
              : size(selectedPhotos) > 0
              ? map(selectedPhotos, (p) => p.url)
              : props.photos
                  .filter((p) => p.type && p.type.includes("CONTEXT"))
                  .map((p) => p.url)
          }
          detectionId={detectionId}
        />
        {/* <CreateProfile
          handleProfileCreated={handleCreateProfile}
          dacId={dacId}
          detectionId={detectionId}
          deviceId={deviceId}
          type={props.profileType}
          contextPhotos={props.details.contextPhotos}
          ocr={ocr}
          lpr={lpr}
          fr={fr}
          handleCancel={() => setRenderCreateProfile(false)}
        /> */}
      </Dialog>
    );
  }

  if (photoSelectionStep) {
    const photos = getTruckImages(
      get(props, ["details", "truckImages", "contextPhotos"]),
      get(props, ["details", "truckImages", "ocr"]),
      get(props, ["details", "truckImages", "lpr"])
    );

    if (size(photos) === 0) {
      handleSubmit();
      setPhotoSelectionStep(false);
      return null;
    }

    return (
      <Dialog
        open={true}
        fullWidth
        classes={{ root: classes.root, paperScrollPaper: classes.dialog }}
      >
        <Box
          className="text-italic text-54"
          style={{ margin: "30px 20px 0px" }}
        >
          {I18n.get("site_selectPhotosForProfile")}
        </Box>
        <Grid container style={{ height: "100%", padding: "24px" }}>
          {map(photos, (p) => (
            <Grid item key={p.url}>
              <Grid container direction="column">
                <CapturedPhoto
                  type={p.type}
                  img={p.url}
                  values={p.values}
                  photo={p}
                />
              </Grid>
              <Grid
                item
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Checkbox
                  color="primary"
                  checked={isSelected(p)}
                  onChange={() => selectImg(p)}
                  classes={{ root: classes.checkboxRoot }}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid container justify="center" alignItems="center">
          <Grid item style={{ margin: "0px 10px" }}>
            <CustomButton
              color="primary"
              onClick={() => {
                setPhotoSelectionStep(false);
                closeDialog();
              }}
            >
              {I18n.get("site_cancel")}
            </CustomButton>
          </Grid>
          <Grid item style={{ margin: "0px 10px" }}>
            <CustomButton
              variant="contained"
              color="primary"
              onClick={() => {
                handleSubmit();
                setPhotoSelectionStep(false);
              }}
            >
              {I18n.get("next")}
            </CustomButton>
          </Grid>
        </Grid>
      </Dialog>
    );
  }

  return (
    <Dialog
      open={open}
      classes={{ root: classes.root, paperScrollPaper: classes.dialog }}
    >
      {loading ? (
        <Box
          style={{
            height: "100%",
            minHeight: "450px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Loader message={I18n.get("site_overridingProfile")} noDecoration />
        </Box>
      ) : (
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ height: "100%", padding: "12px" }}
        >
          <Grid item style={{ marginBottom: "20px" }}>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className="dialogTitle">
                {I18n.get("site_overrideMsg")}
              </Grid>
              <Grid item xs={2} className={classes.closeBtn}>
                <CloseIcon closeFunction={closeDialog} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ padding: "0px 42px", marginBottom: "20px" }}>
            <ProfileMatch
              profile={props.currentProfile}
              lov={lov}
              searchValue={""}
              className={classes.profileBox}
              potentialMatches={potentialMatches}
            />
          </Grid>
          <Grid item style={{ padding: "0px 42px" }}>
            <hr />
            <Box className="text-87 bold-500 text-center">
              {I18n.get("site_with")}
            </Box>
          </Grid>
          <Grid item xs style={{ paddingRight: "42px" }}>
            <OverrideProfileSearch
              currentProfile={props.currentProfile}
              lov={lov}
              selectedProfile={selectedProfile}
              setSelectedProfile={setSelectedProfile}
              initialSearchValues={
                profileType !== 1 ? getOcrLprFromPhotos(props.photos) : null
              }
              profileType={profileType}
            />
          </Grid>
          <Grid style={{ padding: "0px 42px", marginTop: "20px" }}>
            <Box className="text-87 bold-500">
              {I18n.get("site_reasonForOverride")}
            </Box>
            <CustomInput
              name="description"
              value={overrideReason}
              onChange={(e) => setOverrideReason(e.target.value)}
              multiline={true}
              height="120px"
            />
          </Grid>
          <Grid item style={{ textAlign: "center", margin: "24px 0px 12px" }}>
            <CustomButton
              color="primary"
              onClick={closeDialog}
              style={{
                marginRight: "10px",
              }}
            >
              {I18n.get("site_cancel")}
            </CustomButton>
            <CustomButton
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              style={{ marginLeft: "10px" }}
              disabled={isEmpty(selectedProfile)}
            >
              {I18n.get("site_confirm")}
            </CustomButton>
          </Grid>
        </Grid>
      )}
    </Dialog>
  );
};

OverrideDialogForm.propTypes = {
  profileType: PropTypes.any,
  currentProfile: PropTypes.object,
  details: PropTypes.shape({
    dacId: PropTypes.any,
    detectionId: PropTypes.any,
    handleProfileOverride: PropTypes.func,
    ocr: PropTypes.array,
    lpr: PropTypes.array,
    fr: PropTypes.array,
  }).isRequired,
  language: PropTypes.string,
  blockLiveEvents: PropTypes.bool,
  zoneId: PropTypes.number,
  buttonVariant: PropTypes.oneOf(["text", "contained", "outlined"]),
  lov: PropTypes.object,
  photos: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(OverrideDialogForm));
